import { Page } from '../layout'
import { Box, Flex } from 'ui'
import { WorkerDetails } from './components/WorkerDetails'
import { WorkerProfileProvider } from './context/WorkerProfileProvider'
import { ScheduleOverview } from './components/ScheduleOverview'
import { useParams } from 'react-router'

export const WorkerProfilePage = () => {
  const params = useParams<{ workerId: string }>()
  const workerId = Number(params.workerId as string)

  return (
    <WorkerProfileProvider workerId={workerId}>
      <Page>
        <Flex flexWrap={'wrap'}>
          <Box width={[1, 1, 1, 3 / 5]}>
            <WorkerDetails />
          </Box>
          <Box width={[1, 1, 1, 2 / 5]} pl={[0, 0, 0, 5]} pt={[4, 6]}>
            <ScheduleOverview />
          </Box>
        </Flex>
      </Page>
    </WorkerProfileProvider>
  )
}
